import Registration from './TabPages/Registration'
import Policies from './TabPages/Policies'
import Details from './TabPages/Details'
import Participants from './TabPages/Participants'
import LiveTime from './TabPages/LiveTime'
import Results from './TabPages/Results'
import Volunteers from './TabPages/Volunteers'
import Contact from './TabPages/Contact'
import Media from './TabPages/Media'
import Links from './TabPages/Links.js'
import Welcome from './TabPages/Welcome.js'

export const renderTabContent = ({ activeTab, eventDetails, isTabDisabled, today, category, item }) => {
  switch (activeTab) {
    case 'welcome':
      return <Welcome {...{ eventDetails }} />

    case 'details':
      return <Details {...{ eventDetails, category, item }} />

    case 'policies':
      return <Policies {...{ eventDetails }}/>

    case 'registration':
      return <Registration {...{ eventDetails }} />

    case 'participants':
      return <Participants {...{ eventDetails }} />

    case 'live':
      return <LiveTime {...{ eventDetails, isTabDisabled, today }} />

    case 'results':
      return <Results {...{ eventDetails, isTabDisabled, today }} />

    case 'volunteers':
      return <Volunteers />

    case 'contact':
      return <Contact race={eventDetails} />

    case 'media':
      return <Media {...{ eventDetails }} />

    case 'links':
      return <Links {...{ eventDetails }} />
    default:
      return null
  }
}
